<?xml version="1.0" encoding="UTF-8"?>
<svg id="Ebene_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <defs>
    <style>
      .cls-1 {
        fill: #875f31;
      }
    </style>
  </defs>
  <rect class="cls-1" x="55.36" y="1.28" width="3.2" height="14.08"/>
  <rect class="cls-1" x="55.36" y="1.28" width="3.2" height="14.08" transform="translate(65.28 -48.64) rotate(90)"/>
  <path class="cls-1" d="M61.5,19.59c-1.4.57-2.94.89-4.54.89-6.72,0-12.16-5.44-12.16-12.16,0-1.83.42-3.57,1.15-5.13-4.22-2.04-8.95-3.19-13.95-3.19C14.33,0,0,14.33,0,32s14.33,32,32,32,32-14.33,32-32c0-4.4-.89-8.59-2.5-12.41ZM26.35,46.01l-12.27-22.97h4.76l9.89,18.5-2.38,4.47ZM37.65,46.04l-12.29-23h4.14l2.5,4.7,2.51-4.7h4.15l-4.59,8.58,3.35,6.24,7.91-14.82h4.6l-12.27,23Z"/>
</svg>